import { hsl, darken, lighten } from 'polished';

export interface ThemeInterface {
  terminalBg: string;
  screenLgMin: string;
  dividerColor: string;
  primaryColor: string;
  primaryDarkColor: string;
  primaryDarkerColor: string;
  primaryLightColor: string;
  primaryLighterColor: string;
  whiteText: string;
  grayText: string;
  blackText: string;
  grayBackground: string;
}

const primaryColor = process.env.SYNCRO ? '#2599b6' : '#6965c2';

export const theme: ThemeInterface = {
  primaryColor,
  primaryDarkColor: darken(0.1)(primaryColor),
  primaryDarkerColor: darken(0.2)(primaryColor),
  primaryLightColor: lighten(0.2)(primaryColor),
  primaryLighterColor: lighten(0.35)(primaryColor),
  whiteText: 'white',
  grayText: hsl(0, 0, 0.3),
  blackText: hsl(0, 0, 0),
  grayBackground: hsl(0, 0, 0.88),
  terminalBg: '#33394d',
  screenLgMin: '1200px',
  dividerColor: 'rgba(34, 36, 38, .15)',
};
